// Function to set a cookie with a domain
function setCookie(name, value, days, domain) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    var domainAttribute = domain ? "; domain=" + domain : "";
    document.cookie = name + "=" + (value || "") + expires + domainAttribute + "; path=/";
}

// Utility function to get a cookie
function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

// Never auto-redirect while previewed inside the Shopify theme editor - a
// cross-domain navigation there gets reported as "Page is redirecting to an
// unsupported URL" and the editor refuses to load the page.
function isThemeEditor() {
    return !!(window.Shopify && window.Shopify.designMode);
}

// Redirect to the latest newUrl when the site loads
document.addEventListener("DOMContentLoaded", function() {
    if (isThemeEditor()) {
        return;
    }

    var latestNewUrl = getCookie("newUrl");
    if (latestNewUrl) {
        var currentUrl = new URL(window.location.href);
        var targetUrl = new URL(latestNewUrl);

        // Log the current URL and the latest new URL
        console.log("Current URL:", currentUrl.href);
        console.log("Latest newUrl:", latestNewUrl);

        // Compare the base URLs (protocol + host)
        if (currentUrl.origin !== targetUrl.origin) {
            var newRedirectUrl = targetUrl.origin + currentUrl.pathname + currentUrl.search;
            window.location.href = newRedirectUrl;
        }
    }
});

// Silently auto-assign a region based on Shopify's own IP-detected country, the
// first time a visitor shows up with no prior choice. The modal never auto-shows;
// it's only opened manually via showModal() (the globe button).
window.onload = function() {
    if (isThemeEditor()) {
        return;
    }

    var urlParams = new URLSearchParams(window.location.search);
    var lastClickedParam = urlParams.get('lastClicked');

    // If the lastClicked parameter is present (arriving from a cross-domain
    // redirect), re-seed the cookie on this domain.
    if (lastClickedParam) {
        setCookie("lastClicked", lastClickedParam, 1, ".lacabra.com");
    }

    // A selectedRegion cookie means a choice (auto or manual) was already made.
    if (getCookie("selectedRegion")) {
        return;
    }

    var onUsStore = window.location.hostname === 'us.lacabra.com';

    if (onUsStore) {
        // us.lacabra.com's own Markets are US-only, so it can't reliably tell
        // a non-US visitor apart from a US one - never auto-redirect away from
        // here, only lacabra.com -> us.lacabra.com auto-redirects. A visitor who
        // lands here by mistake can still switch manually via the globe button.
        setCookie("selectedRegion", "us", 7, ".lacabra.com");
        setCookie("newUrl", window.location.origin, 7, ".lacabra.com");
        return;
    }

    if (window.ShopifyDetectedCountryCode === 'US') {
        redirectToRegion('us');
    } else {
        // Already on the right store - just remember it, no navigation needed.
        setCookie("selectedRegion", "eu", 7, ".lacabra.com");
        setCookie("newUrl", window.location.origin, 7, ".lacabra.com");
    }
}

// Function to close the modal
function closeModal() {
    var modal = document.getElementById("store-switch-banner");
    modal.style.display = "none";

    // Store the current timestamp as the last clicked time in a cookie
    setCookie("lastClicked", new Date().getTime(), 1, ".lacabra.com");
}

// Function to redirect to the regional store
function redirectToRegion(region) {
    if (isThemeEditor()) {
        return;
    }

    var currentUrl = new URL(window.location.href);
    var path = currentUrl.pathname;
    var search = currentUrl.search;

    var newUrl;
    if (region === 'us') {
        path = path.replace(/\/(da|de)(\/|$)/, '/');
        newUrl = 'https://us.lacabra.com' + path + search;
    } else if (region === 'eu') {
        newUrl = 'https://lacabra.com' + path + search;
    } else {
        newUrl = 'https://lacabra.com' + path + search;
    }

    // Add the showBanner parameter to the URL
    if (search) {
        newUrl += '&showBanner=false';
    } else {
        newUrl += '?showBanner=false';
    }

    // Store the selected region in a cookie
    setCookie("selectedRegion", region, 7, ".lacabra.com");

    // Store the current timestamp as the last clicked time in a cookie
    setCookie("lastClicked", new Date().getTime(), 1, ".lacabra.com");

    // Add the lastClicked cookie value to the URL
    var lastClicked = getCookie("lastClicked");
    if (lastClicked) {
        newUrl += '&lastClicked=' + encodeURIComponent(lastClicked);
    }

    // Extract the base URL from the newUrl
    var urlObject = new URL(newUrl);
    var baseUrl = urlObject.origin;

    // Store the baseUrl in a cookie
    setCookie("newUrl", baseUrl, 7, ".lacabra.com");

    window.location.href = newUrl;
}

// Function to show the modal
function showModal() {
    var modal = document.getElementById("store-switch-banner");
    modal.style.display = "flex";
}

// Update the announcement bar text and mobile menu region text based on the selected region
document.addEventListener("DOMContentLoaded", function() {
    var selectedRegion = getCookie("selectedRegion");
    if (selectedRegion) {
        // Update the announcement bar text
        var announcementMessage = document.querySelector('.store-switch .announcement-bar__message');
        if (announcementMessage) {
            if (selectedRegion === 'eu') {
                announcementMessage.textContent = 'EU';
            } else if (selectedRegion === 'us') {
                announcementMessage.textContent = 'US';
            } else {
                announcementMessage.textContent = 'ROW';
            }
        }

        // Update the mobile menu region text
        var mobileRegionText = document.getElementById("mobileRegionText");
        if (mobileRegionText) {
            if (selectedRegion === 'eu') {
                mobileRegionText.textContent = 'EU';
            } else if (selectedRegion === 'us') {
                mobileRegionText.textContent = 'US';
            } else {
                mobileRegionText.textContent = 'ROW';
            }
        }

        // Update the header drawer region text
        var drawerRegionText = document.getElementById("drawerRegionText");
        if (drawerRegionText) {
            if (selectedRegion === 'eu') {
                drawerRegionText.textContent = 'EU';
            } else if (selectedRegion === 'us') {
                drawerRegionText.textContent = 'US';
            } else {
                drawerRegionText.textContent = 'ROW';
            }
        }
    }
});